import { Component, OnInit } from '@angular/core';

import { SharedService } from '../../services/shared.service';

@Component({
    selector: 'app-shared-header-cadastro',
    templateUrl: 'shared-header-cadastro.component.html'
})

export class SharedHeaderCadastroComponent implements OnInit {

    constructor(private sharedService: SharedService) { }

    ngOnInit() { }

    goBack() {
        return this.sharedService.goBack();
    }
}
